import { pluralise } from './helper-functions.js';

/** @typedef {{ dropdownId: string, value: string, text: string[] }} Option */


/** @param {Record<string, any>} productObj @param {number} subscriptionPct @return {Record<number, Option[]>} */
export function createPurchaseTypeOptions(productObj, subscriptionPct) {
  return productObj.variants.reduce((/** @type {any} */ acc, /** @type {any} */ variant) => {
    const variantId = variant.id;
    const price = variant.price / 100;
    acc[variantId] = [
      { dropdownId: 'purchaseTypeOptions', value: 'subscription', text: [`Subscription (Save ${subscriptionPct}%*)`] },
      { dropdownId: 'purchaseTypeOptions', value: 'onetime', text: [`One-Time Purchase`, `£${price.toFixed(2)}`] },
    ];
    return acc;
  }, {})

}


/** @param {Record<string, any>} productObj @param {number} subscriptionPct @return {Record<number, Option[]>} */
export function createQuantityOptions(productObj, subscriptionPct) {
  return productObj.variants.reduce((/** @type {any} */ acc, /** @type {any} */ variant) => {
    const variantId = variant.id;
    acc[variantId] = [1, 2, 3].map((qty)  => {
      const discountedPrice = (1 - Number(subscriptionPct) / 100) *  (variant.price / 100);
      return {
        dropdownId: 'quantityOptions',
        value: qty.toString(),
        text: [`${qty} ${pluralise('Unit', qty)} (Save 10%*)`, `£${(qty * discountedPrice).toFixed(2)}`],
      };
    });
    return acc;
  }, {})
}


/** @param {Record<string, any>} productObj @return {Option[]} */
export function createFrequencyOptions(productObj) {
  const sellingPlans = productObj.selling_plan_groups?.[0]?.selling_plans;
  return sellingPlans.map((/** @type {any} */ plan) /** @return {Option} */ => {
    const frequencyAndUnit = plan.options.find((/** @type {any} */ option) => option.name === 'Order Frequency and Unit')?.value;
    const frequency = Number(frequencyAndUnit?.split('-')?.[0]);
    return {
      dropdownId: 'frequencyOptions',
      sellingPlanId: plan.id,
      value: frequency,
      text: [`Every ${frequency} ${pluralise('Month', frequency)}`],
    };
  });
}


/** @param {Record<string, any>} productObj @return {Option[]} */
export function createVariantOptions(productObj) {
  return productObj.variants.map((/** @type {any} */ variant) => {
    return {
      dropdownId: 'variantOptions',
      value: variant.id,
      text: [variant.title],
    }
  })
}